import { useState } from "react";
import { useTranslation } from "react-i18next";
import "./CreateDangerousItem.scss";
import { Link } from "react-router-dom";
import { adminApi } from "../../../utils/api";
import { showSuccessToast, showErrorToast } from "../../../utils/toastNotifications";

export const CreateDangerousItem = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
    price: 0,
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<{[key: string]: string}>({});
  const [token, setToken] = useState(localStorage.getItem("token"))
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = (): boolean => {
    const newErrors: {[key: string]: string} = {};
    if (!formData.name.trim()) newErrors.name = t('dangerousItems:validation.nameRequired');
    if (!formData.price || formData.price <= 0) newErrors.price = t('dangerousItems:validation.priceRequired');
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const submitItem = async () => {
    if (!validateForm()) {
      showErrorToast(t('dangerousItems:validation.fillAllFields'));
      return;
    }
    setLoading(true);
    setErrors({});

    try {
      const response = await adminApi.call('/dangerousitem', 'POST', formData);

      if (!response.success) {
        showErrorToast(response.error || "Failed to create dangerous item");
        return;
      }

      showSuccessToast("Dangerous item created successfully!");
      setFormData({ name: "", price: 0 }); // Reset form
    } catch (error) {
      showErrorToast("Error: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="text-primary">Create Dangerous Item</h2>
        <Link to="/dangerous-items" className="btn btn-secondary">
          <i className="fa fa-arrow-left"></i> Back to Index
        </Link>
      </div>
      <div className="mb-3">
        <label className="form-label">Name</label>
        <input
          type="text"
          className="form-control"
          name="name"
          value={formData.name}
          onChange={handleInputChange}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Price</label>
        <input
          type="number"
          className="form-control"
          name="price"
          value={formData.price}
          onChange={handleInputChange}
        />
      </div>

      <div className="text-center">
        <button
          className="btn btn-primary"
          onClick={submitItem}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>
      </div>
    </div>
  );
};
